import SCAN_STATUS from '@/modules/markets/constants/scan-status.constant';
import { Expose, Transform } from 'class-transformer';

export default class RatesScanStatusModel {
    @Expose()
    @Transform((_, plain) => plain.doc_status)
    status!: SCAN_STATUS;
}
